import React from 'react';

import ButtonLink from '../../../../elements/ButtonLink';
import JoinEventFromParent from './JoinEventFromParent';
import connectSubEvent from './connectSubEvent';

const JoinEvent = props => {
    const {event, i18n} = props;

    if (event.allow_join_from_parent) {
        return <JoinEventFromParent {...props} />;
    } else if (event.signup_url) {
        return <ButtonLink style={event._local.styles.button} href={event.signup_url}>
            {i18n['label.event-signup']}
        </ButtonLink>;
    }
    console.warn('Event not joinable: ', event);
    return null;
};

export default connectSubEvent(JoinEvent);
